/**
 * The Ratkaisut tile's solutions grouped by the pivot point they answer
 * (#1431). The backend sends them by votes, then content; a group sits where
 * its first solution would, keeps that order inside, and solutions without a
 * pivot come last.
 *
 * @param {{ pivotKey?: string|null, pivotLabel?: string|null }[]} solutions
 * @returns {{ key: string|null, label: string|null, solutions: object[] }[]}
 */
export function groupByPivot(solutions = []) {
  const groups = new Map();
  const loose = { key: null, label: null, solutions: [] };
  for (const sol of solutions) {
    if (!sol.pivotKey) {
      loose.solutions.push(sol);
      continue;
    }
    if (!groups.has(sol.pivotKey)) groups.set(sol.pivotKey, { key: sol.pivotKey, label: sol.pivotLabel || null, solutions: [] });
    groups.get(sol.pivotKey).solutions.push(sol);
  }
  return loose.solutions.length ? [...groups.values(), loose] : [...groups.values()];
}
